import Decimal from 'decimal.js-light'
import toFormat from 'toformat'

export default toFormat(Decimal)
